
<div #mytemplate>
  <app-guest-recommendations-view-desktop *ngIf="isDesktopMode() && !property?.noshowRecommendationOnBooklet && property.poi"></app-guest-recommendations-view-desktop>
</div>

